import AbstractPersistence from "./AbstractPersistence"

const LocalStoragePersistence = Object.create(AbstractPersistence)

LocalStoragePersistence.storage = window.localStorage

export default LocalStoragePersistence
